import React from "react";
import styled from "styled-components";
import TextArea from "../Elements/TextArea";

const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.light};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 3px;
  padding: 20px;
`;

const Message = styled.div`
  color: ${({ theme }) => theme.colors.gray};
`;
const Title = styled.div`
  font-family: ${({ theme }) => theme.fonts.bold};
`;

const MessageArea = ({ title, message, placeholder, onChange }) => {
  return (
    <Wrapper>
      <Title>{title}</Title>
      <Message dangerouslySetInnerHTML={message} />
      <TextArea
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
      />
    </Wrapper>
  );
};

export default MessageArea;
